import { Controller } from "@hotwired/stimulus";
import consumer from "../../../channels/consumer";

export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 30000 },
    channelName: String,
    channelId: String,
  };

  connect() {
    this.intervalId = setInterval(() => this.sendHeartbeat(), this.intervalValue);
    if (this.channelNameValue && this.channelIdValue) {
      this.subscribeToChannel();
    }
  }

  disconnect() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    this.subscription?.unsubscribe();
  }

  subscribeToChannel() {
    this.subscription = consumer.subscriptions.create(
      { channel: this.channelNameValue, stat_dec_id: this.channelIdValue },
      {
        received: (data) => {
          if (data.redirect_to) {
            window.location.href = data.redirect_to;
          }
        },
      },
    );
  }

  async sendHeartbeat() {
    if (!this.urlValue) return;

    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content;
    await fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": csrfToken,
        "Content-Type": "application/json",
      },
    });
  }
}
